import { ISelectOption } from 'models';

export function createSelectOptionsFromEnum<T extends Record<string, string>>(enumObj: T): ISelectOption<keyof T>[] {
    return Object.keys(enumObj).map((key) => ({
        value: key,
        label: enumObj[key as keyof T],
    }));
}
